import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Button, Space } from 'components';
import { LeadStatusBadge, LeadStatusType } from 'components/common/StatusBadge/LeadStatusBadge';
import styles from './styles.module.scss';

interface StatusChangeDropdownProps {
  disabled: boolean;
  menuItems: { key: string; label: string }[];
  onStatusClick: (status: LeadStatusType) => void;
}

export const StatusChangeDropdown: React.FC<StatusChangeDropdownProps> = ({ disabled, menuItems, onStatusClick }) => (
  <Dropdown
    menu={{
      items: menuItems.map((item) => ({
        label: <LeadStatusBadge type={item.key as LeadStatusType} />,
        key: item.key,
      })),
      onClick: ({ key }) => onStatusClick(key as LeadStatusType),
    }}
    trigger={['click']}
    disabled={disabled}
  >
    <Button className={styles.statusBtn}>
      <Space>
        Change Status
        <DownOutlined />
      </Space>
    </Button>
  </Dropdown>
);
